import { Box, makeStyles, Tab, Tabs, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  getAllCategoriesAndSubCategories,
  getVendorMenus,
  getVendorProducts,
  getVendorWithSuperCategory,
  getAllSuperCategory,
  pushEvent
} from '../../../store/actions/user/User';
import { saveEventData } from "../../../utils/events-handler"
import { handleOpen } from '../../../store/reducers/userReducer';
import Items from './Menus';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { scroller } from "react-scroll";
import Moment from 'moment';
import Footer from '../Footer/Footer';
import ReactPixel from 'react-facebook-pixel';

const useStyles = makeStyles((theme) => ({
  productMenuListing: {
    paddingTop: '4rem',
    height: 'auto',
    width: '100%',
    background: '#f9f9f8'
  },
  menuContainer: {
    flexGrow: 1,
    paddingRight: '2rem',
    backgroundColor: 'white',
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  horizontalTabs: {
    position: '-webkit-sticky',
    position: 'sticky',
    top: 70,
    padding: '0px'
  },
  indicator: {
    backgroundColor: 'black',
    height: '4px',
    color: 'black',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px'
  },
  tabItem: {
    '&:focus': {
      outline: '0px'
    }
  },
  vendorDetail: {
    display: 'flex',
    width: '100%',
    minHeight: '250px',
    paddingTop: '30px',
    backgroundRepeat: 'no-repeat !important',
    backgroundSize: 'cover !important',
    backgroundPosition: 'center !important',
  },
  vendorName: {
    fontSize: '30px',
    fontWeight: 'bold',
    paddingTop: '3%',
    color: 'black'
  },
  vendorImage: {
    width: '380px'
  },
  vendorSubDetail: {
    width: '20%',
    textAlign: 'center',
    marginLeft: '40%',
    marginTop: '3%',
    backgroundColor: 'rgb(255,255,255, 0.5)',
    borderRadius: '15px',
    marginBottom: '2%',
    [theme.breakpoints.down('sm')]: {
      width: '52%',
      marginLeft: '24%',
    }
  },
  distance: {
    color: 'black',
    paddingRight: '5px',
    fontWeight: 'bold'
  },
  vendorLocation: {
    // display: 'flex'
    color: 'black'
  },
  street: {
    fontWeight: 'bold'
  },
  vendorStatus: {
    color: 'green',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  vendorDuration: {
    fontSize: '14px',
    fontWeight: 'bold'
  },
  horiButton: {
    alignItems: 'center !important'
  },
  tabSelected: {
    outline: 'none !important',
    fontWeight: 'bold',
    color: 'black'
  }
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

function HorizonatalA11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
    style: {
      justifyContent: 'center'
    }
  };
}

const RestaurantMenu = (props) => {
  var closed = false
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [todayDay, setTodayDay] = useState('sunday');
  const [subCategoryValue, setSubCategoryValue] = React.useState(0);
  const [vendor, updateVendor] = useState({});
  const [isRestaurant, updateIsRestaurant] = useState(false);
  const [allProducts, updateProducts] = useState([]);
  const [allMenus, updateMenus] = useState([]);
  const [categories, updateCategories] = useState([]);
  const [reachedTop, setReachedTop] = React.useState(false);
  useEffect(() => {
    const { superCategoryId, vendorId } = props.match.params;
    const payload = {
      superCategoryId: superCategoryId,
      latitude: localStorage.getItem('latitude') || '-33.865143',
      longitude: localStorage.getItem('longitude') || '151.209900'
    };
    props.getVendorWithSuperCategory(payload);
    props.getAllCategoriesAndSubCategories(superCategoryId, vendorId).then((resp) => {
      updateCategories(resp?.data || []);
    });
    props.getVendorProducts(vendorId).then((resp) => {
      updateProducts(resp?.data || []);
    });
    props.getAllSuperCategory().then((resp) => {
      if (resp) {
        resp.data.map((item) => {
          if (item.isResturant) {
            props.getVendorMenus(vendorId).then((resp) => {
              updateMenus(resp?.data || []);
            });
          }
          if (item.id === superCategoryId) {
            updateIsRestaurant(item.isRestaurant);
          }
        });
      }
    });
    whichDayIsToday();
  }, []);

  const scrollToSection = (className, index) => {
    const subCategories = categories[value].subCategories
    if (index == subCategories.length - 1)
      scroller.scrollTo(className, {
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
      });
    else {
      var element = document.getElementsByClassName(className)[0];
      element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }

  };

  useEffect(() => {
    if (props?.vendorBySuperCategory) {
      const { vendorId } = props.match.params;
      const tempVendor = props?.vendorBySuperCategory?.find(
        (item) => item.id === vendorId
      );
      updateVendor(tempVendor);
      let eventsApiCall;
      if (tempVendor?.eventTag) {
        const options = {
          autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
          debug: false, // enable logs
        };
        ReactPixel.init('831925394401262', {}, options);
        ReactPixel.trackCustom(tempVendor.eventTag, { 'url': window.location.href });
        saveEventData(props.pushEvent, tempVendor.eventTag)
        eventsApiCall = setInterval(() => {
          saveEventData(props.pushEvent, tempVendor.eventTag)
        }, 120000)
      }else{
        saveEventData(props.pushEvent, "RestaurantView")
        eventsApiCall = setInterval(() => {
          saveEventData(props.pushEvent, "RestaurantView")
        }, 120000)
      }
    }
  }, [props?.vendorBySuperCategory]);

  const handleChange = (event, newValue) => {
    setSubCategoryValue(0);
    setValue(newValue);
  };

  const handleSubCategoryChange = (event, newValue) => {
    setSubCategoryValue(newValue);
    scrollToSection(`horizontal-tabs-${newValue}`, newValue)
  };
  function checkInViewport() {
    const leftTab = document.getElementById('mainTab')
    if (leftTab) {
      const rectLeftTab = leftTab.getBoundingClientRect();
      if (rectLeftTab.top <= 70) {
        setReachedTop(true)
      } else {
        setReachedTop(false)
      }
    }
    setTimeout(() => {
      const subCategories = categories[value]?.subCategories;
      var max = -1
      for (var i = 0; i < (subCategories ? subCategories.length : 0); i++) {
        const element = document.getElementsByClassName(`horizontal-tabs-${i}`)[0];
        if (element) {
          const rect = element.getBoundingClientRect();
          if (i == 0) {
            if (rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > (window.innerHeight || document.documentElement.clientHeight)) {
              max = 0
            }
          }
          const available = (
            (rect.top >= 0) &&
            rect.left >= 0 &&
            (rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          )
          if (available) {
            if (max < i) {
              max = i
            }
          }
        }
      }
      if (max == -1) {
        // if(subCategoryValue !== (subCategories ? subCategories.length : 0) - 1 ){
        //   setSubCategoryValue(0);
        // }
      } else {
        setSubCategoryValue(max);
      }
    }, 500)

  }

  const whichDayIsToday = () => {
    let d = Moment().day();
    let weekday = new Array(7);
    weekday[0] = 'sunday';
    weekday[1] = 'monday';
    weekday[2] = 'tuesday';
    weekday[3] = 'wednesday';
    weekday[4] = 'thursday';
    weekday[5] = 'friday';
    weekday[6] = 'saturday';
    setTodayDay(weekday[d]);
  };

  const handleStatus = (data) => {
    const days = data.days
    const opentime = data.opentime
    const closetime = data.closetime
    closed = !handleOpen(opentime, closetime, days)
    if (!closed) {
      return (<div className={classes.vendorStatus}>{'Open'}</div>)
    } else {
      return (<div className={classes.vendorStatus} style={{ color: 'red' }}>{'Closed'}</div>)
    }
  }

  window.onscroll = checkInViewport
  return (
    <div className={classes.productMenuListing}>
      <div className={classes.vendorDetail} style={{
        background: `url(${vendor?.logo})`,
      }}>
        <div className={classes.vendorSubDetail}>
          <div className={classes.vendorName}>{vendor?.name}</div>
          <div className={classes.vendorLocation}>
            <div className={classes.street}>{vendor?.address?.street}</div>
            <div className={classes.distance}>
              {vendor?.distance ? (vendor?.distance / 1000).toFixed(2) + ' KM' : ''}
            </div>
            {vendor?.active && handleStatus({
              days: vendor?.address?.days,
              closetime: vendor?.timing[todayDay]?.closeTime
              ,
              opentime: vendor?.timing[todayDay]?.openTime
            })}
            {vendor?.distanceAndDuration?.duration && (<div className={classes.vendorDuration}><AccessTimeIcon style={{ fontSize: 14 }} /> {vendor?.distanceAndDuration?.duration.text}</div>)}
          </div>
        </div>
      </div>
      {categories?.length ? (
        <div className={classes.menuContainer} id="mainTab">
          <div style={reachedTop ? { position: 'fixed', top: '70px', background: '#fff', width: '100%', backgroundColor: 'white' } : { backgroundColor: 'white' }}>
            <Tabs
              classes={{
                indicator: classes.indicator,
                centered: true,
              }}
              textColor="inherit"
              variant="scrollable"
              scrollButtons="on"
              aria-label="Vertical tabs example"
              value={value}
              onChange={handleChange}
              style={{ borderBottom: '1px solid rgb(231, 231, 231)' }}
            >
              {categories?.map((category, index) => (
                <Tab
                  classes={{
                    wrapper: classes.horiButton,
                    selected: classes.tabSelected
                  }}
                  com
                  label={category.name}
                  {...HorizonatalA11yProps(0)}
                />
              ))}
            </Tabs>
          </div>
          {[...Array(categories?.length).keys()].map((index) => (
            <TabPanel value={value} index={index}>
              <div style={reachedTop ? { position: 'fixed', top: '120px', background: '#fff', width: '100%' } : {}}>
                <Tabs
                  classes={{
                    indicator: classes.indicator,
                    centered: true,
                  }}
                  textColor="inherit"
                  variant="scrollable"
                  scrollButtons="on"
                  aria-label="scrollable auto tabs example"
                  value={subCategoryValue}
                  style={{ borderBottom: '1px solid rgb(231, 231, 231)' }}
                  onChange={handleSubCategoryChange}
                >
                  {categories[index]?.subCategories?.map((subCategory) => (
                    <Tab
                      label={subCategory?.name}
                      com
                      {...HorizonatalA11yProps(0)}
                      classes={{
                        wrapper: classes.horiButton,
                        selected: classes.tabSelected
                      }}
                    />
                  ))}
                </Tabs>
              </div>
              {[...Array(categories[index]?.subCategories?.length).keys()].map(
                (subCategoryIndex) => (
                  <HorizontalTabPanel
                    value={subCategoryValue}
                    index={subCategoryIndex}
                  >
                    <div style={{
                      textAlign: 'left',
                      fontSize: '22px',
                      fontWeight: 'bold',
                      marginBottom: '20px',
                      paddingLeft: '2rem',
                    }}>{categories[index]?.subCategories[subCategoryIndex].name}</div>
                    <Items
                      index={subCategoryIndex}
                      categoryId={categories[index]?.id}
                      subCategoryId={
                        categories[index]?.subCategories[subCategoryIndex].id
                      }
                      closed={closed}
                      isRestaurant={isRestaurant}
                      vendor={vendor}
                      vendorId={props?.match?.params?.vendorId}
                      allProducts={allProducts}
                      allMenus={allMenus}
                    />
                  </HorizontalTabPanel>
                )
              )}
            </TabPanel>
          ))}
        </div>
      ) : null}
      <div id="footer">
        <Footer />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allProducts: state.user.products,
  allMenus: state.user.menus,
  categories: state.user.categories,
  vendor: state.shared.vendor,
  vendorBySuperCategory: state.user.vendorBySuperCategory,
  superCategories: state.user.superCategories
});

const mapDispatchToProps = (dispatch) => ({
  getAllCategoriesAndSubCategories: (superCategoryid, vendorId) =>
    dispatch(getAllCategoriesAndSubCategories(superCategoryid, vendorId)),
  getVendorProducts: (vendorId) => dispatch(getVendorProducts(vendorId)),
  getVendorMenus: (vendorId) => dispatch(getVendorMenus(vendorId)),
  pushEvent: (details) => dispatch(pushEvent(details)),
  getVendorWithSuperCategory: (superCategory) =>
    dispatch(getVendorWithSuperCategory(superCategory)),
  getAllSuperCategory: () => dispatch(getAllSuperCategory())
});

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantMenu);

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{ marginTop: '20px' }}
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} padding={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const HorizontalTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{ zIndex: 9999 }}
      id={`scrollable-auto-tabpanel-${index}`}
      className={`horizontal-tabs-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {(
        <Box p={3} style={{ paddingTop: '20px' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};
